<script>
    import General from '@/services/General'
    import validationMessages from '@/components/validations'
    import { required, minLength, numeric } from "vuelidate/lib/validators"
    import moment from "moment"
    import "vue-multiselect/dist/vue-multiselect.min.css"

    export default {
        components:{
            validationMessages
        },
        data() {
            return {
                showModal: false,
                tryingToSubmit: false,
                submitted: false,
                date: new Date(),
                deeplink: {
                    name: '',
                    method: '',
                    second_level:'',
                    second_level_value: '',
                },
                showSecondLevel: false,
                methodOption: [],
                secondLevelOptions: [],
                second_level_title:'',
                csrf_token: localStorage.getItem('csrf_token')
            };
        },
        validations: {
            deeplink:{
                name: {
                    required,
                }
            },
        },
        methods: {
            refreshDeeplinkCampaign() {
                this.$emit('onRefresh') //event from parent
            },
            createDeeplinkCampaign(){
                this.tryingToSubmit = true
                this.submitted = true
                this.$v.$touch()

                if (this.$v.$invalid) {
                    this.tryingToSubmit = false
                    return;
                } 

                let formData = new FormData();
                formData.append('name', this.deeplink.name)
                formData.append('method', this.deeplink.method)
                formData.append('second_level', this.deeplink.second_level)


                General.createDeeplinkCampaign(formData)
                    .then((response) => {
                        const res = response.data.guid ? response.data.guid : false;
                        const error = response.data.error ? response.data.error : '';
                        if(res){
                            this.successmsg('Deeplink  Created!');
                            this.refreshDeeplinkCampaign();
                            this.closeModal();
                        }else{
                            this.failedmsg('Failed to create new deeplink campaign!')
                        }
                    })
                    .catch(error => {
                        const resData = error.response.data.error ? error.response.data.error : 'Failed';
                        const errorMsg = Array.isArray(resData) ? resData[0] : resData;
                        this.failedmsg(errorMsg)
                    })
                    .finally(() => {
                        this.tryingToSubmit = false
                    })
                
            },
            closeModal() {
                this.showModal = false
            },
            removeImage(){
                this.$refs['file-input'].reset()
            },

            resetProps(){
                this.submitted = false
                this.deeplink.name = ''
                this.deeplink.method = ''
            },

            getDeeplinkCampaignMethods(){
                General.getDeeplinkCampaignMethods()
                    .then((response) => {
                        this.methodOption = response.data.data ? response.data.data : []
                    })
                    .catch(error => {
                        this.methodOption = []
                    })
            },

             getDeeplinkSecondLevel(second_level) {
                General.getDeeplinkSecondLevelOptions(second_level)
                  .then(response => {
                    this.secondLevelOptions = response.data.data || [];
                       if(this.secondLevelOptions.length > 0){
                            this.showSecondLevel = true;
                        }
                  })
                  .catch(() => {
                     this.secondLevelOptions = [];
                     this.showSecondLevel = false;
                  });
              },
        },

        watch: {
            'deeplink.method'(newMethod) {
              const selected = this.methodOption.find((m) => m.method === newMethod);
                 this.deeplink.second_level = selected ? selected.second_level : '';
                 this.deeplink.second_level_value = '';
                 this.secondLevelOptions = [];
                 if (this.deeplink.second_level) {
                 this.second_level_title = selected.second_level_description;
                 //  this.showSecondLevel = true;
                   this.getDeeplinkSecondLevel(this.deeplink.second_level);
                 } else {
                    this.showSecondLevel = false;
                    this.deeplink.second_level = '';
                 }
            },
        },
    };
</script>

<template>
    <b-modal @shown="getDeeplinkCampaignMethods()" id="add_new_deeplink_campaign" size="md" v-model="showModal" @hidden="resetProps" title="Add New Deeplink Campaign" title-class="font-18">
    <form @submit.prevent="createDeeplinkCampaign">
        <div class="row">
          <div class="col-12">
                <b-form-group label="Name" label-for="deeplink.name" class="mb-3">
                    <b-form-input
                            v-model.trim="deeplink.name"
                            type="text"
                            id="deeplink.name"
                            :class="{
                                'is-invalid': submitted && $v.deeplink.name.$error,
                                }"
                    >
                    </b-form-input>
                    <validationMessages v-if="submitted" :fieldName="'Name'" :validationName="$v.deeplink.name"></validationMessages>
                </b-form-group>


                <div class="mb-3">
                    <label class="control-label form-label">App screen</label>
                    <select v-model="deeplink.method" class="form-control form-select" name="option" type="select"  >
                        <option value=''>Home screen </option>
                        <option v-for="option in methodOption" :key="option.method" :value="option.method">
                            {{ option.description }}
                        </option>
                    </select>
                </div>


                 <div class="mb-3" v-if="showSecondLevel">
                    <label class="control-label form-label">{{second_level_title}}</label>
                    <select v-model="deeplink.second_level" class="form-control form-select" name="option" type="select"  >
                        <option v-for="option in secondLevelOptions" :key="option.id" :value="option.id">
                            {{ option.name }}
                        </option>
                    </select>
                </div>



          </div>
        </div>

        <input type="hidden" name="csrf_token" v-model="csrf_token">
      </form>

        <template v-slot:modal-footer>
            <b-button variant="light" @click="closeModal">Close</b-button>
            <b-button variant="primary" @click="createDeeplinkCampaign" :disabled="tryingToSubmit">
                <b-spinner v-show="tryingToSubmit" small></b-spinner>
                Submit
            </b-button>
        </template>

    </b-modal>
 
</template>